<template>
  <b-row class="shadow-sm top-app-navigation align-items-center" style="box-shadow:0 0 0.25rem rgba(0, 0, 0, 0.485) !important; position: relative; z-index:1000">
    <b-col :cols="isProjectHeader? 'auto': ''" class="m-0 p-0">
      <b-navbar>
        <b-btn :to="{name:'project-list'}" class="mr-2" style="background:rgba(255,255,255,0.15);border:none">
          <font-awesome-icon :icon="['fas', 'arrow-left']" />
        </b-btn>

        <b-btn :to="{name:'home'}" class="mr-2" style="background:rgba(255,255,255,0.15);border:none">
          <font-awesome-icon class="text-white" icon="home" />
        </b-btn>

        <b-btn  @click.prevent="reload()"  style="background:rgba(255,255,255,0.15);border:none">
          <font-awesome-icon :icon="['fas', 'rotate-right']" />
        </b-btn>
        
        <!-- <b-navbar-nav>
          <b-nav-item :to="{name:'project-list'}" >
            <span class="font-weight-normal text-white">{{ $t("menu.projects") }}</span>
          </b-nav-item>
        </b-navbar-nav> -->
      </b-navbar>
    </b-col>
    <b-col v-if="isProjectHeader" class="p-2">
      <project-header  />
    </b-col>
    <b-col cols="auto" v-if="isProjectHeader" >
      <b-btn variant="text" class="text-white">
          <small>
            <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" v-if="project.estimation_status == 'completed'"/>
            Divalto process 
            <u v-if="project.estimation_status == 'completed'">Completed</u>
            <u v-else>Not started</u>
          </small>
      </b-btn>
    </b-col>
  
    <b-col cols="auto" class="p-0">
      <template v-if="isProjectHeader">
        <b-btn variant="dark" class="border-white mr-2" v-b-tooltip.hover :title="$t('menu.roof_section')" @click.prevent="openInspectionLink()">
          Open inspection 
          &nbsp;
          <font-awesome-icon :icon="['fas', 'up-right-from-square']" />
        </b-btn>
        <b-btn variant="dark" class="border-white mr-2" v-b-tooltip.hover :title="$t('menu.roof_section')" @click.prevent="openReportLink()">
          Report 
          &nbsp;
          <font-awesome-icon :icon="['fas', 'up-right-from-square']" />
        </b-btn>
        <b-btn variant="dark" class="border-white mr-2" v-b-tooltip.hover :title="$t('menu.roof_section')" @click.prevent="openSidebar('roof-section-list')">
          <font-awesome-icon icon="draw-polygon" />
        </b-btn>
        <!-- <b-btn variant="dark" class="border-white mr-2" v-b-tooltip.hover :title="$t('menu.equipments')" @click.prevent="openSidebar('equipment-list')">
          <font-awesome-icon icon="screwdriver-wrench" />
        </b-btn> -->
        <b-btn variant="dark" class="border-white mr-2" v-b-tooltip.hover title="Project Settings" @click.prevent="openSidebar('project-settings')">
          <font-awesome-icon icon="cog" />
        </b-btn>
        <b-btn variant="dark" class="border-white mr-2" v-b-tooltip.hover title="Layers" @click.prevent="openSidebar('layers')">
          <font-awesome-icon icon="layer-group" />
        </b-btn>
      </template>
      <router-link to="/settings/equipments">
        <font-awesome-icon class="text-primary" icon="cog" />
      </router-link>
      <b-dropdown variant="outline-light" right class="b-0 mr-2">
        <template #button-content>
          <span class="font-weight-normal text-capitalize">{{ $i18n.locale }}</span>
        </template>
        <b-dropdown-item @click="setLangLocale('en')">English (en)</b-dropdown-item>
        <b-dropdown-item @click="setLangLocale('fr')">Français (fr)</b-dropdown-item>
      </b-dropdown>
    </b-col>

  </b-row>
</template>
<script>
import ProjectHeader from '@/components/ProjectHeader'
import {ProjectMixin} from '@/mixins'
import appConfig from '@/config/app.config'
export default {
  name: "AppHeader",
  components: {
    ProjectHeader
  },
  mixins:[ProjectMixin],
  data(){
    return {
      search: ""
    }
  },
  computed:{
    isProjectHeader(){
      return this.$route.meta.projectHeader
    },

    tilePersistStatus(){
      if(this.orthoAssetDetail){
        return (this.orthoAssetDetail.metadata || {}).tile_persist_status
      }
    },
  },
  mounted(){
    this.search = this.$route.query.q
  },
  methods:{
    setLangLocale(locale){
      this.$store.commit('session/setLang', locale)
      this.$i18n.locale = locale
    },
    open(){
      window.location.href= `/projects/39/pdf`
    },
    submitSearch() {
      if(this.search == this.$route.query.q) return;
      
      /** Initial Values */
      let query = {
        q: this.search,
      }

      /** Find Path on basis route meta */
      let search = this.$route.meta.search
      if(!search){
        search = {
          path: this.$route.path
        }
      }
      else if("path" in search && (!("absolute" in search) || !search.absolute)){
        /** Add accountId for relative path  */
        search.path = `${search.path}`
      }
      
      /** add query params */
      search.query = query
      
      this.$router.push(search);
    },
    async downloadExcel(){
      const projectId = this.$route.params.id
      await this.$store.dispatch('session/refresh')
      const token = this.$store.getters['session/currentToken']
      const url = `${appConfig.API_BASE_URL}/projects/${projectId}/sections/export?token=${token}`
      window.location.href = url
    },

    openDivaltoFile(){
      if(this.project.estimation_status == 'completed'){
        this.$store.dispatch('projects/divaltoUrl',{ id: this.$route.params.id, config: {} }).then((res)=>{
          window.open(res.estimation_url, '_blank');
        })
      }
    },

    reload(){
      window.location.reload()
    },

    openReportLink() {
      let locale = this.$store.getters['session/lang']
      this.$store.dispatch('projects/reportAuthToken', { id: this.$route.params.id }).then(resp =>{
        window.open(`/projects/${this.$route.params.id}/report?token=${resp.data.token}&locale=${locale}`, '_blank');
      })
    },

    openInspectionLink(){
      window.parent.postMessage({
        type: 'redirectTo',
        url: '/ui/v2/inspections/' + this.project.inspection_id
      }, '*');

    }

  }
}
</script>
<style>
.lang-dropdown button{
  padding:0;
  color: white;
  
}
.top-app-navigation .btn-outline-primary{
  background: white;
}

.nav-link-dense .nav-link{
  padding-left:0
}
</style>
